import React from 'react';
import {Button, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {ServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useSubscriptionDialogsStateStore} from 'presentation/components/SubscriptionDialogs/store/useSubscriptionDialogsStateStore';
import {StyledCardContainer, StyledHeader} from './styles';

const {digitalInvoice} = translations['pt-br'].privateFlow.home;

function DigitalInvoiceCard() {
	const setDialogs = useSubscriptionDialogsStateStore(state => state.updateState);

	const handleOpenSubscriptionModal = () => {
		setDialogs({
			isSubscriptionModalOpen: true,
		});
	};

	return (
		<StyledCardContainer elevation={0}>
			<StyledHeader>
				<Typography variant="body2" component={'span'} color="text.primary">
					{digitalInvoice.line1}
					<b>{digitalInvoice.line2}</b>
				</Typography>
				<IconIllustration
					variant="primary"
					customIconName="receipt-long-filled"
					size="small"
				/>
			</StyledHeader>

			<Button
				data-tag-id={ServicesTaggingEnum.CLICK_ADESAO_BOLETO_DIGITAL}
				variant="outlined"
				size="medium"
				fullWidth
				onClick={handleOpenSubscriptionModal}>
				{digitalInvoice.subscribe}
			</Button>
		</StyledCardContainer>
	);
}

export default DigitalInvoiceCard;
